import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import type { components } from "@/api/schema";

import { bundleKeys } from "./bundle-keys";

type Marketplace = components["parameters"]["Marketplace"];

export interface RecomputeListingVars {
  code: string;
  marketplace: Marketplace;
}

/**
 * Manual "Recompute" bundle-row action (Stage 2). Forces a
 * sellable/allocation_sellable recompute for one listing on one marketplace —
 * `POST /v1/listings/{code}/recompute?marketplace=X` — mirroring sino-legacy's
 * Calculate button. Returns 204; we refetch the listings list to surface the
 * refreshed own_stock values.
 */
export function useRecomputeListing() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ code, marketplace }: RecomputeListingVars) => {
      const { error } = await apiClient.POST("/v1/listings/{code}/recompute", {
        params: { path: { code }, query: { marketplace } },
      });
      if (error) throw error;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: bundleKeys.all });
    },
  });
}
